import { useTranslation } from 'react-i18next';
import { S, Icon } from '../../regureStyles';
import PermissionGate from '../../../components/PermissionGate';

const Actions = ({ request, handleDownload, downloading, handleRemind, reminding, handleCancel, cancelling, handleReseal, resealing }) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 20 }}>
      {request.status === 'completed' && (
        <button
          onClick={handleDownload}
          disabled={downloading}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 20px',
            background: S.burgundy,
            border: 'none',
            borderRadius: 10,
            fontSize: 14,
            fontWeight: 600,
            color: '#fff',
            cursor: downloading ? 'default' : 'pointer',
            opacity: downloading ? 0.7 : 1,
          }}
        >
          <Icon name='download' color='#fff' size={16} />
          {downloading ? t('screens.esign.actionFetching') : t('screens.esign.actionDownload')}
        </button>
      )}
      {['pending', 'partially_signed'].includes(request.status) && (
        <button
          onClick={handleRemind}
          disabled={reminding}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 20px',
            background: S.bgCard,
            border: `1px solid ${S.borderLight}`,
            borderRadius: 10,
            fontSize: 14,
            fontWeight: 500,
            color: S.textSecondary,
            cursor: reminding ? 'default' : 'pointer',
          }}
        >
          <Icon name='bell' color={S.textMuted} size={16} />
          {reminding ? t('screens.esign.actionSending') : t('screens.esign.actionRemind')}
        </button>
      )}
      {['pending', 'partially_signed', 'draft'].includes(request.status) && (
        <button
          onClick={handleCancel}
          disabled={cancelling}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 20px',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: 10,
            fontSize: 14,
            fontWeight: 500,
            color: '#991b1b',
            cursor: cancelling ? 'default' : 'pointer',
          }}
        >
          <Icon name='x' color='#991b1b' size={16} />
          {cancelling ? t('screens.esign.actionCancelling') : t('screens.esign.actionCancel')}
        </button>
      )}
      {request.status === 'seal_failed' && (
        <PermissionGate resource='eSign' action='reseal'>
          <button
            onClick={handleReseal}
            disabled={resealing}
            title={request.sealError ? `Seal error: ${request.sealError}` : ''}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 20px',
              background: '#fffbeb',
              border: '1px solid #fde68a',
              borderRadius: 10,
              fontSize: 14,
              fontWeight: 600,
              color: '#92400e',
              cursor: resealing ? 'default' : 'pointer',
              opacity: resealing ? 0.7 : 1,
            }}
          >
            <Icon name='refresh' color='#92400e' size={16} />
            {resealing ? t('screens.esign.actionResealing', { defaultValue: 'Resealing…' }) : t('screens.esign.actionRetrySeal', { defaultValue: 'Retry seal' })}
          </button>
        </PermissionGate>
      )}
    </div>
  );
};

export default Actions;
